export const AVAILABLE_STATUSES = {
  PENDING: 'PENDING',
  PAID: 'PAID',
};
